import Http from 'services/Http';

export const DEFAULT_CONFIG = {
  enabled: false,
  complianceMode: false,
  pdfGenerationDay: 1,
  autoSendViaOmmnio: true,
  messageType: 'normal',
  retentionYears: 4,
  teams: [],
};

const TimeTrackingCompliance = {
  async listEmployeeReports(employeeId) {
    const { data } = await Http.get(`/v1/time-tracking/reports/${employeeId}`);
    return data?.reports || [];
  },

  async getReportDownloadUrl(employeeId, month) {
    const { data } = await Http.get(`/v1/time-tracking/reports/${employeeId}/${month}`);
    return data?.pdfUrl;
  },

  async regenerateReport(employeeId, month) {
    const { data } = await Http.post(`/v1/time-tracking/reports/${employeeId}/${month}/regenerate`);
    return data;
  },

  async getMonthlyExcelReportUrl(companyId, month) {
    const { data } = await Http.get(`/v1/company/${companyId}/time-tracking/export/${month}`);
    return data?.excelUrl;
  },
};

export default TimeTrackingCompliance;
